// Localized labels for all option arrays exported from quoteConfig.js
// Keys map to the raw English label used as the canonical id.
// Helper functions return `{label, desc}` localized for the active language.

const LABELS = {
  pt: {
    // STRUCTURE_MATERIALS
    "Aluminum": "Alumínio",
    "Steel": "Aço",
    "Cedar Wood": "Madeira de cedro",
    "Metal Frame": "Estrutura metálica",
    "Pressure Treated Wood": "Madeira tratada",
    "Composite Material": "Material compósito",
    // ROOF_TYPES
    "Hardtop": "Teto rígido",
    "Soft Top": "Teto macio",
    "Polycarbonate Roof": "Telhado de policarbonato",
    "Galvanized Steel Roof": "Telhado de aço galvanizado",
    "Louvered Roof": "Telhado com lâminas",
    "Insulated Roof": "Telhado isolado",
    // SHED_MATERIALS
    "Plastic Shed": "Galpão de plástico",
    "Resin Shed": "Galpão de resina",
    "Metal Shed": "Galpão de metal",
    "Wooden Shed": "Galpão de madeira",
    // FOUNDATION_TYPES
    "Existing Concrete Slab": "Laje de concreto existente",
    "Existing Pavers": "Pavimentação existente",
    "Existing Gravel Area": "Área de cascalho existente",
    "Need Wood Platform": "Precisa de plataforma de madeira",
    "Need Concrete Foundation": "Precisa de fundação de concreto",
    "Need Gravel Base": "Precisa de base de cascalho",
    // PLATFORM_OPTIONS
    "Pressure Treated Platform": "Plataforma de madeira tratada",
    "Elevated Platform": "Plataforma elevada",
    "Reinforced Heavy-Duty Base": "Base reforçada de alta resistência",
    // INSTALL_LOCATIONS
    "Backyard": "Quintal",
    "Front yard": "Jardim da frente",
    "Side yard": "Lateral da casa",
    "Deck / Patio": "Deck / Pátio",
    "Rooftop": "Cobertura",
    "Other": "Outro",
    // BOXES_OPTIONS
    "Not delivered yet": "Ainda não entregue",
    "1 box": "1 caixa",
    "2 boxes": "2 caixas",
    "3 boxes": "3 caixas",
    "4+ boxes": "4+ caixas",
    "Pallet": "Pallet",
    // SURFACE_TYPE_OPTIONS
    "Concrete": "Concreto",
    "Pavers": "Pavimentação",
    "Grass": "Grama",
    "Dirt": "Terra",
    "Deck": "Deck",
    // TIME_WINDOW_OPTIONS
    "Morning": "Manhã",
    "Afternoon": "Tarde",
    "Evening": "Noite",
    "Flexible": "Flexível",
    // ANCHORING_COUNT_OPTIONS
    "4 anchors": "4 âncoras",
    "6 anchors": "6 âncoras",
    // OPTIONAL_ADDONS
    "Cardboard / Box Breakdown": "Quebra de papelão / caixas",
    "Disposal Service": "Serviço de descarte",
    // QUOTE_CATEGORIES
    "Gazebo": "Gazebo",
    "Pergola": "Pérgola",
    "Sheds": "Galpões",
    "Sauna": "Sauna",
    "Gym Equipment": "Equipamento de academia",
    "Playground": "Playground",
    "Outdoor Furniture": "Móveis de exterior",
    "Outdoor Structures": "Estruturas externas",
    // DESCRIPTIONS
    "8 AM – 12 PM": "8h – 12h",
    "12 PM – 4 PM": "12h – 16h",
    "4 PM – 7 PM": "16h – 19h",
    "Any time of day": "Qualquer horário",
  },
  es: {
    // STRUCTURE_MATERIALS
    "Aluminum": "Aluminio",
    "Steel": "Acero",
    "Cedar Wood": "Madera de cedro",
    "Metal Frame": "Estructura metálica",
    "Pressure Treated Wood": "Madera tratada",
    "Composite Material": "Material compuesto",
    // ROOF_TYPES
    "Hardtop": "Techo rígido",
    "Soft Top": "Techo blando",
    "Polycarbonate Roof": "Techo de policarbonato",
    "Galvanized Steel Roof": "Techo de acero galvanizado",
    "Louvered Roof": "Techo con lamas",
    "Insulated Roof": "Techo aislado",
    // SHED_MATERIALS
    "Plastic Shed": "Cobertizo de plástico",
    "Resin Shed": "Cobertizo de resina",
    "Metal Shed": "Cobertizo de metal",
    "Wooden Shed": "Cobertizo de madera",
    // FOUNDATION_TYPES
    "Existing Concrete Slab": "Losa de concreto existente",
    "Existing Pavers": "Adoquines existentes",
    "Existing Gravel Area": "Área de grava existente",
    "Need Wood Platform": "Necesita plataforma de madera",
    "Need Concrete Foundation": "Necesita base de concreto",
    "Need Gravel Base": "Necesita base de grava",
    // PLATFORM_OPTIONS
    "Pressure Treated Platform": "Plataforma de madera tratada",
    "Elevated Platform": "Plataforma elevada",
    "Reinforced Heavy-Duty Base": "Base reforzada de alta resistencia",
    // INSTALL_LOCATIONS
    "Backyard": "Patio trasero",
    "Front yard": "Jardín delantero",
    "Side yard": "Lateral",
    "Deck / Patio": "Deck / Patio",
    "Rooftop": "Azotea",
    "Other": "Otro",
    // BOXES_OPTIONS
    "Not delivered yet": "Aún no entregado",
    "1 box": "1 caja",
    "2 boxes": "2 cajas",
    "3 boxes": "3 cajas",
    "4+ boxes": "4+ cajas",
    "Pallet": "Pallet",
    // SURFACE_TYPE_OPTIONS
    "Concrete": "Concreto",
    "Pavers": "Adoquines",
    "Grass": "Césped",
    "Dirt": "Tierra",
    "Deck": "Deck",
    // TIME_WINDOW_OPTIONS
    "Morning": "Mañana",
    "Afternoon": "Tarde",
    "Evening": "Noche",
    "Flexible": "Flexible",
    // ANCHORING_COUNT_OPTIONS
    "4 anchors": "4 anclajes",
    "6 anchors": "6 anclajes",
    // OPTIONAL_ADDONS
    "Cardboard / Box Breakdown": "Trituración de cartón / cajas",
    "Disposal Service": "Servicio de desecho",
    // QUOTE_CATEGORIES
    "Gazebo": "Gazebo",
    "Pergola": "Pérgola",
    "Sheds": "Cobertizos",
    "Sauna": "Sauna",
    "Gym Equipment": "Equipo de gimnasio",
    "Playground": "Parque infantil",
    "Outdoor Furniture": "Muebles de exterior",
    "Outdoor Structures": "Estructuras exteriores",
    // DESCRIPTIONS
    "8 AM – 12 PM": "8h – 12h",
    "12 PM – 4 PM": "12h – 16h",
    "4 PM – 7 PM": "16h – 19h",
    "Any time of day": "Cualquier momento",
  },
};

/** Translate a string label. Falls back to the original (English) if no map exists. */
export const tr = (text, lang) => {
  if (!text || !lang || lang === "en") return text;
  const map = LABELS[lang];
  return (map && map[text]) || text;
};

/** Localize an option (string OR object). Returns {id,label,desc}. */
export const localizeOption = (opt, lang) => {
  if (typeof opt === "string") {
    return { id: opt, label: tr(opt, lang), desc: null };
  }
  return {
    id: opt.id ?? opt.label,
    label: tr(opt.label, lang),
    desc: opt.desc ? tr(opt.desc, lang) : null,
    raw: opt,
  };
};

/** Localize an entire array of options. */
export const localizeOptions = (options, lang) =>
  (options || []).map((o) => localizeOption(o, lang));
